import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withImage from '../../../../shared/components/utils/hoc/withImage';
import FlavourConfig from '../../../../shared/config/flavours';

const PilotAppLogo = styled.img<React.CSSProperties>`
  position: absolute;
  bottom: ${43 * Screen.widthRatio}px;
  height: ${43 * Screen.widthRatio}px;
  right: ${124 * Screen.widthRatio}px;
`;

PilotAppLogo.defaultProps = {
  src: FlavourConfig.images.bwLogo,
};

export default withImage(PilotAppLogo);
